import React from 'react'

import { AppIconProps } from '@/types/components'

export const ClosingIcon = (props: AppIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill={props.fill || 'none'}
      width={props.width}
      height={props.width}
      viewBox='0 0 24.414 24.414'
    >
      <g
        id='Group_6462'
        data-name='Group 6462'
        transform='translate(-1855.592 172.541)'
      >
        <path
          id='Path_827'
          data-name='Path 827'
          d='M25,25l-7.333-7.333m2.444-6.111A8.556,8.556,0,1,1,11.556,3,8.556,8.556,0,0,1,20.111,11.556Z'
          transform='translate(1853.592 -174.541)'
          fill='none'
          stroke='#353946'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <text
          id='_'
          data-name='$'
          transform='translate(1864.861 -159.699)'
          fill='#353946'
          fontSize='9'
          fontFamily='Inter-SemiBold, Inter'
          fontWeight='600'
          letterSpacing='-0.032em'
        >
          <tspan
            x='-2.921'
            y='0'
          >
            $
          </tspan>
        </text>
      </g>
    </svg>
  )
}
